/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Invite_TitleInputs */

const en_us2_body_assessment_invite_title = /** @type {(inputs: Body_Assessment_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Want to follow how your body changes?`)
};

const pt_br2_body_assessment_invite_title = /** @type {(inputs: Body_Assessment_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quer acompanhar como o seu corpo muda?`)
};

const es_419_body_assessment_invite_title = /** @type {(inputs: Body_Assessment_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Quieres seguir cómo cambia tu cuerpo?`)
};

const pt_pt2_body_assessment_invite_title = /** @type {(inputs: Body_Assessment_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queres acompanhar como o teu corpo muda?`)
};

const fr_fr2_body_assessment_invite_title = /** @type {(inputs: Body_Assessment_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envie de suivre l'évolution de ton corps ?`)
};

const de_de2_body_assessment_invite_title = /** @type {(inputs: Body_Assessment_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Willst du sehen, wie sich dein Körper verändert?`)
};

const it_it2_body_assessment_invite_title = /** @type {(inputs: Body_Assessment_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuoi seguire come cambia il tuo corpo?`)
};

/**
* | output |
* | --- |
* | "Want to follow how your body changes?" |
*
* @param {Body_Assessment_Invite_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_invite_title = /** @type {((inputs?: Body_Assessment_Invite_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Invite_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_invite_title(inputs)
	if (locale === "es-419") return es_419_body_assessment_invite_title(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_invite_title(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_invite_title(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_invite_title(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_invite_title(inputs)
	return en_us2_body_assessment_invite_title(inputs)
});
export { body_assessment_invite_title as "body-assessment.invite_title" }